<script>
    import { onMount } from "svelte";
    import * as api from "../utiles/api";
    import * as store from "../stores/store";
    import * as Common from "../utiles/common.util";
    import { push } from "svelte-spa-router";
    import { PushNotifications } from "@capacitor/push-notifications";
    import { Capacitor } from "@capacitor/core";
    import { Preferences } from "@capacitor/preferences";

    onMount(() => {
        // 로그인 상태 체크
        apiGetStatus();
    });

    async function apiGetStatus() {
        if (Capacitor.isNativePlatform()) {
            const permStatus = await PushNotifications.requestPermissions();

            if (permStatus.receive !== "granted") {
                // alert("푸시 알림 권한이 거부되었습니다.");
                return;
            }
        }

        const token = await Common.getStoredToken();

        if (token) {
            if (location.href.includes("Login")) {
                push("/AsList");
            }
        } else {
            if (!location.href.includes("Login")) {
                push("/Login");
            }
        }
    }

    async function logout() {
        try {
            await api.get(`/account/logout`);
        } catch (err) {
            console.error("logout api error", err);
            // api 실패해도 무시하고 진행
        }

        // 스토어 초기화
        store.accountInfo.set(null);
        store.jwt_token.set(null);
        store.refreshToken.set(null);

        // Preferences 초기화
        try {
            await Preferences.clear();
        } catch (err) {
            console.error("Preferences clear error", err);
        }

        // 로그인 페이지로 이동
        push("/Login");
    }
</script>

<!-- svelte-ignore a11y-missing-attribute -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="btm">
    <div
        class="btm-in {window.location.hash.startsWith('#/As') ? 'btm-on' : ''}"
        on:click={() => {
            if (window.location.hash === "#/AsList") {
                window.location.reload();
            } else {
                push("/AsList");
            }
        }}
    >
        <img
            src="../img/{window.location.hash.startsWith('#/As')
                ? 'ico_btm_list_on.png'
                : 'ico_btm_list.png'}"
        />
        <p>접수요청</p>
    </div>

    <div
        class="btm-in {window.location.hash.startsWith('#/ProcessList') ||
        window.location.hash.startsWith('#/ProcessForm')
            ? 'btm-on'
            : ''}"
        on:click={() => {
            if (window.location.hash === "#/ProcessList") {
                window.location.reload();
            } else {
                push("/ProcessList");
            }
        }}
    >
        <img
            src="../img/{window.location.hash.startsWith('#/ProcessList') ||
            window.location.hash.startsWith('#/ProcessForm')
                ? 'ico_btm_as_on.png'
                : 'ico_btm_as.png'}"
        />
        <p>처리진행</p>
    </div>

    <div
        class="btm-in {window.location.hash.startsWith('#/EndProcessList') ||
        window.location.hash.startsWith('#/ProcessDetail') ||
        window.location.hash.startsWith('#/EndProcessDetail')
            ? 'btm-on'
            : ''}"
        on:click={() => {
            if (window.location.hash === "#/EndProcess") {
                window.location.reload();
            } else {
                push("/EndProcessList");
            }
        }}
    >
        <img
            src="../img/{window.location.hash.startsWith('#/EndProcessList') ||
            window.location.hash.startsWith('#/ProcessDetail') ||
            window.location.hash.startsWith('#/EndProcessDetail')
                ? 'ico_btm_as_c_on.png'
                : 'ico_btm_as_c.png'}"
        />
        <p>완료목록</p>
    </div>

    <div class="btm-in" on:click={logout}>
        <img src="../img/ico_btm_logout.png" />
        <p>로그아웃</p>
    </div>
</div>

<style>
    .btm {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 70px; /* Slightly taller for easy touch */
        display: flex;
        justify-content: space-around;
        align-items: center;
        background-color: var(--card-bg) !important;
        border-top: 1px solid var(--border-color) !important;
        padding-bottom: env(safe-area-inset-bottom); /* iPhone notch support */
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
        z-index: 100;
        transition:
            background-color 0.3s ease,
            border-color 0.3s ease;
    }

    .btm-in {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 25%;
        height: 100%;
        cursor: pointer;
        opacity: 0.6;
        transition: all 0.2s ease;
    }

    .btm-in img {
        width: 24px;
        height: 24px;
        margin-bottom: 4px;
        transition: transform 0.2s ease;
    }

    .btm-in p {
        margin: 0;
        font-size: 0.75rem !important;
        font-weight: 500 !important;
        color: var(--text-color) !important;
    }

    .btm-on {
        opacity: 1;
    }

    .btm-on img {
        transform: scale(1.1);
    }

    .btm-on p {
        color: var(--primary-color) !important;
        font-weight: 700 !important;
    }

    /* Dark mode icon visibility tweak */
    :global([data-theme="dark"]) .btm-in:not(.btm-on) img {
        filter: invert(1) brightness(0.8);
    }
</style>
